module.exports = __webpack_public_path__ + "img/imweb_design_7.6b015c89.png";